import React from 'react';

const NameField = ({ name }) => (
    <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', fontSize: 15 }}>
        { name }
    </div>
);

export default NameField;